export default {
  SET_LAST_AKRUAL_UPDATE_TIME(state, timestamp) {
    state.lastAkrualUpdateTime = timestamp
  },
}
